import React, { createContext, useReducer, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { AuthReducer, initialState } from "./AuthReducer";
import Auth from "./Auth";
import { API } from "../api/API";
import * as ACTIONS from "./actions";
import EmptySidebarLayout from "uiwidgets/layouts/EmptySidebarLayout";
import AppSpinner from "uiwidgets/AppSpinner";
import { USER_ACCOUNT_URL } from "../config/config";
import { extractError } from "api/ErrorUtil";
import ErrorBlock from "../uiwidgets/ErrorBlock";
import _ from "lodash";



const auth = new Auth();

export const SecurityContext = createContext();
const SecurityContextProvider = props => {

  const [authReducerState, dispatchAuthReducer] = useReducer(AuthReducer, initialState);
  const [accounts, setAccounts] = useState([]);
  const [accountsLoaded, setAccountsLoaded] = useState(false);
  const [apiError, setApiError] = useState({});


  function refreshUserAccounts() {
    let userProfile = auth.getProfile();
    if (!_.isEmpty(userProfile)) {
      fetchUserAccounts(userProfile)
    }
  }

  function fetchUserAccounts(userProfile) {
    //no need to load accounts for admin
    if (userProfile.roles.includes("ROLE_BUSINESS_ADMIN")){
      setAccountsLoaded(true);
      dispatchAuthReducer(ACTIONS.loginSuccess(userProfile));
      console.log("Not fetching account because this is business admin role")
      return;
    }

    console.log("fetching accounts because this is consumer role")
    API.get(USER_ACCOUNT_URL)
      .then(resp => {
        let data = resp.data;
        setAccounts(data);
        setAccountsLoaded(true);
        dispatchAuthReducer(ACTIONS.loginSuccess(userProfile));
      })
      .catch(error => {
        //at this time the user is logged in
        //this should be commented out because this will result only in accounts
        //not showing but the user and get other parts of the application
        //setApiError(extractError(error));
        console.log(error);
        setAccountsLoaded(true);
        dispatchAuthReducer(ACTIONS.loginSuccess(userProfile));

      })
  }
  useEffect(() => {
    //load accounts if there is a profile
    let userProfile = auth.getProfile();
    if (!_.isEmpty(userProfile)) {
      fetchUserAccounts(userProfile)
    } else {
      dispatchAuthReducer(ACTIONS.loginFailure());
    }
  }, []);

  const handleLogout = () => {
    auth.logout();
    dispatchAuthReducer(ACTIONS.logout());
  };

  //Handle authentication from callback
  const handleAuthentication = jwtResp => {
    let userProfile = auth.handleAuth(jwtResp);
    if (!_.isEmpty(userProfile)) {
      fetchUserAccounts(userProfile);
      return userProfile;
    } else {
      dispatchAuthReducer(ACTIONS.loginFailure());
      return null;
    }
  };

  if (!_.isEmpty(apiError)) {
    return <EmptySidebarLayout><ErrorBlock error={apiError} /></EmptySidebarLayout>;
  }

  if (!accountsLoaded && auth.getProfile()) {
    console.log("Accounts spinner");
    return <AppSpinner />;
  }

  return (
    <React.Fragment>
      {
        authReducerState.authAttempted && <SecurityContext.Provider
          value={{
            authState: authReducerState.isAuthenticated,
            profile: authReducerState.profile,
            handleAuth: jwtResp => handleAuthentication(jwtResp),
            handleLogout: handleLogout,
            accounts: accounts,
            refreshUserAccounts: refreshUserAccounts
          }}
        >
          {props.children}
        </SecurityContext.Provider>
      }
    </React.Fragment>
  );
};

SecurityContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default SecurityContextProvider;
